import { FlowActionTypes } from '../store/flow/action-types';
import { isDeveloperFlow } from '../store/flow/selectors';
import { executeCallbackIfEmailSubmitted } from '../flow-management/checkForEmailUtils';
import { prefillCompanyDomainFromEmail } from './prefillCompanyDomainFromEmail';
import { prefillHubInterest } from './prefillHubInterest';
import { AppActionTypes } from '../store/app/action-types';
import { prefillEmbeddedSignupData, prefillQueryParamSignupData } from './prefillSignupData';
export const PrefillingMiddleware = store => next => action => {
  const dispatchResult = next(action);

  if (action.type === AppActionTypes.AppStarted) {
    store.dispatch(prefillQueryParamSignupData());
  }

  if (action.type === AppActionTypes.EmbeddedPrefill) {
    store.dispatch(prefillEmbeddedSignupData(action.data));
  }

  if (action.type === FlowActionTypes.Load) {
    store.dispatch(prefillHubInterest());
  }

  if (isDeveloperFlow()) {
    executeCallbackIfEmailSubmitted(store.getState(), action, email => {
      store.dispatch(prefillCompanyDomainFromEmail(email));
    });
  }

  return dispatchResult;
};